// Minimal Redux slice to keep chat state global & persistent across routes

const OPEN_LOGS_CHAT = 'logsChatAssistant/OPEN';
const CLOSE_LOGS_CHAT = 'logsChatAssistant/CLOSE';

// export const openLogsChat = ({ sessionId, phone }) => ({ // old without to from
export const openLogsChat = ({ sessionId, phone, to, from }) => ({
  type: OPEN_LOGS_CHAT,
  // payload: { sessionId: sessionId || '', phone: phone || '' }
   payload: {
   sessionId: sessionId || '',
   phone: phone || '',
   to: to || '',
   from: from || ''
 }
});

export const closeLogsChat = () => ({ type: CLOSE_LOGS_CHAT });

const initialState = {
  isOpen: false,
  sessionId: '',
phone: '',
to: '',
from: ''};

export default function logsChatAssistantReducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_LOGS_CHAT:
      return {
        ...state,
        isOpen: true,
        sessionId: action.payload.sessionId,
        phone: action.payload.phone,
        to: action.payload.to,
        from: action.payload.from      };
    case CLOSE_LOGS_CHAT:
      return {
        ...state,
        isOpen: false,
        sessionId: '',
        phone: '',
        to: '',
        from: ''
      };
    default:
      return state;
  }
}

// Selectors
export const selectLogsChatIsOpen = (s) => s.logsChatAssistant?.isOpen;
export const selectLogsChatSessionId = (s) => s.logsChatAssistant?.sessionId || '';
export const selectLogsChatPhone = (s) => s.logsChatAssistant?.phone || '';
export const selectLogsChatTo = (s) => s.logsChatAssistant?.to || '';
export const selectLogsChatFrom = (s) => s.logsChatAssistant?.from || '';
